import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Auth } from 'aws-amplify'
import { REACT_APP_MAP_URL } from '../../config/settings/environment'
import { AppContainer, Frame, Message } from './Visor.styles'

const VISOR_URL = REACT_APP_MAP_URL
const VISOR_ORIGIN = VISOR_URL ? new URL(VISOR_URL, window.location.href).origin : null

/**
 * The Visor container: embeds the COSMOS viewer (Vue app) and hands it the
 * user's Cognito ID token over postMessage. The viewer asks again
 * (cosmos:token-request) when it has no token or its server answers 401.
 */
const Visor = () => {
  const frame = useRef(null)
  // Alto del iframe = lo que queda de ventana debajo de su borde superior. Con `100vh`
  // la página medía navbar + encabezado + 100vh y quedaba con scroll propio: la rueda
  // sobre el mapa (zoom) terminaba desplazando la página entera.
  const [height, setHeight] = useState('100vh')
  useEffect(() => {
    const fit = () => {
      const node = frame.current
      if (!node) return
      const top = node.getBoundingClientRect().top + window.scrollY
      setHeight(`${Math.max(window.innerHeight - top, 320)}px`)
    }
    fit()
    window.addEventListener('resize', fit)
    return () => window.removeEventListener('resize', fit)
  }, [])

  const sendToken = useCallback(async () => {
    const target = frame.current && frame.current.contentWindow
    if (!target || !VISOR_ORIGIN) return
    try {
      const session = await Auth.currentSession()
      target.postMessage({ type: 'cosmos:token', token: session.getIdToken().getJwtToken() }, VISOR_ORIGIN)
    } catch (error) {
      console.warn('[visor] no Cognito session to pass to the viewer', error)
    }
  }, [])

  useEffect(() => {
    const onMessage = event => {
      if (event.origin !== VISOR_ORIGIN) return
      if (event.data && event.data.type === 'cosmos:token-request') sendToken()
    }
    window.addEventListener('message', onMessage)
    return () => window.removeEventListener('message', onMessage)
  }, [sendToken])

  if (!VISOR_URL) {
    return (
      <AppContainer>
        <Message>REACT_APP_MAP_URL no está configurado.</Message>
      </AppContainer>
    )
  }

  return (
    <AppContainer>
      <Frame
        ref={frame}
        title="Visor COSMOS"
        src={VISOR_URL}
        onLoad={sendToken}
        allow="fullscreen"
        style={{ height }}
      />
    </AppContainer>
  )
}

export default Visor
